import { Input } from '../ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select'
import { Search } from 'lucide-react'

interface SearchFiltersProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  classNameFilter: string
  onClassNameChange: (value: string) => void
  groupFilter: string
  onGroupChange: (value: string) => void
  classNames: string[]
  groups: string[]
}

export const SearchFilters = ({
  searchQuery,
  onSearchChange,
  classNameFilter,
  onClassNameChange,
  groupFilter,
  onGroupChange,
  classNames,
  groups,
}: SearchFiltersProps) => {
  return (
    <div className="space-y-4 bg-card p-6 rounded-lg border shadow-sm">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select value={classNameFilter} onValueChange={onClassNameChange}>
          <SelectTrigger>
            <SelectValue placeholder="Filter by class" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Classes</SelectItem>
            {classNames.map((className) => (
              <SelectItem key={className} value={className}>
                {className}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={groupFilter} onValueChange={onGroupChange}>
          <SelectTrigger>
            <SelectValue placeholder="Filter by group" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Groups</SelectItem>
            {groups.map((group) => (
              <SelectItem key={group} value={group}>
                {group}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
